import api from "./api";

const ProjectVehicleReportService = {
  getReport: async (params) => {
  const response = await api.get("/projectVehicleReport/getReport", {
    params: {
      ...params,
      page: params.page || 1,
      limit: params.limit || 10,
    },
  });

  return response.data;
},
};

export default ProjectVehicleReportService;